import {
  createTheme as defaultCreateTheme,
  ThemeOptions,
  Theme,
} from '@mui/material/styles';

export default function createMuiTheme(options?: ThemeOptions): Theme {
  return defaultCreateTheme(options);
}
